import { render, staticRenderFns } from "./supplier-produce.vue?vue&type=template&id=3063780d&scoped=true"
import script from "./supplier-produce.vue?vue&type=script&lang=js"
export * from "./supplier-produce.vue?vue&type=script&lang=js"
import style0 from "./supplier-produce.vue?vue&type=style&index=0&id=3063780d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3063780d",
  null
  
)

export default component.exports